import { useEffect } from "react"

export const useScrollEvent = ({ enabled, listener }: { enabled: boolean, listener: (this: Window, ev: Event) => any }) => {
  useEffect(() => {
    if (!enabled) {
      return;
    }

    window.addEventListener('touchmove', listener, { passive: false })
    return () => window.removeEventListener('touchmove', listener);
  }, [enabled])
}